
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var OvertimeApplyPage = Vue.extend({})
Vue.component('overtimeApply-page', OvertimeApplyPage)

export default {
  name: 'OvertimeApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/overtimeApply.vue